export const malgorzataSolska = {
    'meta': {
        'title': 'Psycholog, Psychoterapeuta Małgorzata Solska Centrum COLLIGO',
        'description': 'Pracuję z młodzieżą oraz ich rodzicami. Korzystam z metod behawioralno-poznawczych, terapii skoncentrowanej na rozwiązaniach, psychoedukacji.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-malgorzata-solska/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/malgorzata-solska.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog Małgorzata Solska'
        }
    }
}